"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingsProvider = void 0;
const lodash_1 = require("lodash");
const BaseDataProvider_1 = require("./BaseDataProvider");
class RatingsProvider extends BaseDataProvider_1.BaseDataProvider {
    constructor() {
        super(...arguments);
        this.query = (options) => {
            let query = this.refs.ratings();
            query = (0, lodash_1.isNil)(options.itemType) ? query : query.where('itemType', '==', options.itemType);
            query = (0, lodash_1.isNil)(options.itemId) ? query : query.where('itemId', '==', options.itemId);
            query = (0, lodash_1.isNil)(options.ownerId) ? query : query.where('ownerId', '==', options.ownerId);
            query = (0, lodash_1.isNil)(options.limit) ? query : query.limit(options.limit);
            return query;
        };
    }
    async rating(id) {
        return this.docPromise(this.refs.rating(id));
    }
    async ratingsByUser(itemType, itemId, ownerId) {
        const results = await this.find({ itemId, itemType, ownerId });
        return (0, lodash_1.first)(results);
    }
    async ratingsForItem(itemType, itemId) {
        return this.find({ itemId, itemType });
    }
    find(options) {
        return this.collectionPromise(this.query(options));
    }
}
exports.RatingsProvider = RatingsProvider;
//# sourceMappingURL=RatingsProvider.js.map